import axios from 'axios';
import { coef } from './constants';

export const getEuroExchange = async () => {
  try {
    const response = await axios.get(
        `https://us-central1-valid-dragon-359717.cloudfunctions.net/testfn`
    );
        //console.log(response);
    return response?.data;
  } catch (error) {
    console.log("Exchange rete error >>>", error);
  }
}

//C4=SUM(D4:L4)/9+0.56
export const getCoefFour = (printingPagesCount: number): number => (
  printingPagesCount / 9 + 0.56
);

//C4=SUM(D4:L4)/11 + 0.55
export const getCoefFive = (printingPagesCount: number): number => (
  printingPagesCount / 11 + 0.55
);

//M4=300*B4/10000*1.5
export const getPriceEuro = (quantity: number, quantityBorder: number, euro: number): number => (
  euro * quantity / quantityBorder * coef
);

//O4=((M4*C4)+N4)/B4
export const getPriceEuroPerPiece = (priceEuro: number, printingPagesCoef: number, quantity: number, markup: number): number => (
  (priceEuro * printingPagesCoef + markup) / quantity
);

//Q4=P4*O4
export const getPriceRubPerPiece = (euro: number, priceEuroPerPiece: number): number => (
  euro * priceEuroPerPiece
);

export const formatValueToString = (value: number): string => {
  return new Intl.NumberFormat('fr-FR').format(value);
};

export const formatValueToNumber = (value: string, min = 0): number => {
  const numbers = value.match(/\d/g) || [min];
  return parseInt(numbers.join(''));
};